import { useMemo } from 'react';
import { ITEM } from '../../../../utils/common';
import { IMarker } from '../../../../types/marker';
import { TabKey } from '../../../../utils/common';

export function usePointSelection(markers: IMarker[] = [], onChangeActiveKey: (item: any, tabKey: TabKey) => void) {
  const pointOptions = useMemo(() => {
    return markers?.map((item) => ({
      label: item.label,
      value: item.id
    })) ?? [];
  }, [markers]);

  const handleChangePoint = (item: any) => {
    onChangeActiveKey(item, ITEM.VALIDATION);
  };

  return { pointOptions, handleChangePoint };
}
